// extracted by mini-css-extract-plugin
module.exports = {"sec_change_world":"CardList_sec_change_world__2UeLP","content":"CardList_content__3bSxK","title":"CardList_title__3ZOtS","cont_cards":"CardList_cont_cards__20G56"};